// extracted by mini-css-extract-plugin
export default {"letter":"Letter_letter__CmMvC","default":"Letter_default__Blrhg","correct":"Letter_correct__DW4ms","wrong":"Letter_wrong__f4QAy"};